import React from 'src/Packages/Plugins/TechDivision.Journal/node_modules/react'
import { useStore } from 'src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Store/useStore'

/**
 * Overrides src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Components/FilterTag.js
 * The override is registered at /overwriteMapping.js and replaces the original file completely
 */
const FilterTagSelect = (category) => {
    const setFilterState = useStore((state) => state.setFilterState)
    const activeFilterTagUids = useStore((state) => state.activeFilterTagUids)
    const showFilterCount = useStore((state) => state.showFilterCount)
    const resetFilterState = useStore((state) => state.resetFilterState)
    const filter = category.category.tags
    const hideJournalFilterHeadlines = useStore((state) => state.hideJournalFilterHeadlines)

    const checked = activeFilterTagUids.includes(filter.uid)

    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;
        resetFilterState()
        setFilterState(selectedValue, !checked)
    }

    return (
        <div className="select-container">
            <select
                className="journal-list__filter-select"
                onChange={handleSelectChange}
                defaultValue=""
                name="journal-list__filter-select"
            >
                {hideJournalFilterHeadlines ? '' : <option value="" disabled>{category.category.description}</option> }
                {filter.map((option) => (
                    <option key={option.uid} value={option.uid}>
                        {option.name} {!showFilterCount && `(${option.count})`}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default FilterTagSelect
